module.exports = __webpack_public_path__ + "media/images/avatar-2-22722e36b86ae88072bb87a323c5725e.png";